<video controls src="{{{o.url}}}" style="max-height: 50vh"></video>
<a target="_blank" rel="noopener" href="{{{o.url}}}">{{{o.label_download}}}</a>
